import { enum_stripe_product_type_enum } from '../../../generated/graphql'

export const productTypeIsLabProduct = (productType?: enum_stripe_product_type_enum | null) =>
  [
    enum_stripe_product_type_enum.BUNDLE,
    enum_stripe_product_type_enum.LAB_PANEL,
    enum_stripe_product_type_enum.LAB_TEST,
    enum_stripe_product_type_enum.PACKAGE,
  ].some((x) => productType === x)
